import { Injectable, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CompanyObjectivesData } from '../model/company-objectives-data';
import { CurrentUserService } from './current-user.service';

/**
 * Climate risk exposure ("Climate risks" tab).
 *
 * Reduction actions, custom actions and SDGs each have their own service and
 * endpoint — do not add them back here. Bundling them made every save rewrite
 * all four arrays, so two open tabs would overwrite each other.
 */
@Injectable({ providedIn: 'root' })
export class CompanyObjectivesDataService {
  private http = inject(HttpClient);
  private currentUserService = inject(CurrentUserService);

  selectedVulnerabilities = computed(
    () => this.currentUserService.currentUser()?.company?.selectedVulnerabilities ?? [],
  );

  updateSelectedVulnerabilities(
    selectedVulnerabilities: number[],
  ): Observable<CompanyObjectivesData> {
    const companyId = this.currentUserService.currentUser()?.companyId ?? '';
    const previous = this.selectedVulnerabilities();

    this.currentUserService.patchCompany({ selectedVulnerabilities });

    return this.http
      .put<CompanyObjectivesData>(
        `${environment.apiUrl}/company/${companyId}/objectives-data`,
        { selectedVulnerabilities },
      )
      .pipe(
        tap((data) =>
          this.currentUserService.patchCompany({
            selectedVulnerabilities: data.selectedVulnerabilities,
          }),
        ),
        catchError((err) => {
          this.currentUserService.patchCompany({ selectedVulnerabilities: previous });
          return throwError(() => err);
        }),
      );
  }
}
